import '../css/index.scss'
import {handleEvents} from "./events";
import {initDefaultSelect2} from "./select2";
import {disableConsoleLogs} from "./utils";
import {initI18Next} from "./i18next";


$(document).ready(function () {
    //disableConsoleLogs()
    handleEvents()
    initDefaultSelect2()
    initI18Next('common').then(() => {})

})